import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";

import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";

@Component({
  selector: "receipt-page-submit-receipt-modal-upload-files",
  templateUrl:
    "./receipt-page-submit-receipt-modal-upload-files.component.html",
  styleUrls: [
    "./receipt-page-submit-receipt-modal-upload-files.component.scss",
  ],
})
export class ReceiptPageSubmitReceiptModalUploadFilesComponent
  implements OnInit
{
  public translations$: Observable<ITranslations>;
  public selectedFile: File | null = null;
  @Output("fileSelected") public fileSelectedEvent: EventEmitter<File> =
    new EventEmitter<File>();

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }
  public ngOnInit() {}
  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileSelectedEvent.emit(this.selectedFile);
    }
  }

  protected removeFile() {
    this.selectedFile = null;
    this.fileSelectedEvent.emit(this.selectedFile);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal-uplaod-files/receipt-page-submit-receipt-modal-upload-files.component.ts